import React from 'react';
import PropTypes from 'prop-types';

import * as styles from '../styles';

import {open, close} from './actions';

export default class Dialog extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
    };

    static defaultProps = {
        easyCancel: true,
        onClose: () => null,
    }

    constructor(props) {
        super(props);
        this.state = {
            visible: this.props.isOpen,
        };
    }

    componentWillUpdate(nextProps) {
        if (nextProps.isOpen != this.props.isOpen) {
            this.setState({visible: true});
            setTimeout(() => {
                this.setState({visible: false});
                if(this.refs.dialog && this.refs.dialog.style!=null)this.refs.dialog.style.overflow = '';
            }, 2500);
            this.refs.overlay.style.display = 'unset';
            this.refs.dialog.style.overflow = 'hidden';
            window.getComputedStyle(this.refs.overlay).getPropertyValue('display');
        }
    }

    render() {
        return <span>
            {this.props.children && this.props.children.length > 2
                ? <span
                    style={{cursor: 'pointer'}}
                    onClick={() => this.context.store.dispatch(open(this.props.elementId))}>
                    {this.props.children[2]}
                </span>
                : this.renderActivator
                    ? this.renderActivator.bind(this)()
                    : null
            }
            <div
                ref='overlay'
                style={{
                    ...styles.overlay,
                    maxHeight: this.props.isOpen || this.state.visible ? 'unset' : 0,
                    pointerEvents: this.props.isOpen ? 'unset' : 'none',
                    backgroundColor: this.props.isOpen ? styles.overlay.backgroundColor : 'rgba(100, 100, 100, .0)',
                }}
                onClick={event => {
                    event.stopPropagation();
                    if (this.props.easyCancel) {
                        this.context.store.dispatch(close(this.props.elementId));
                        this.props.onClose();
                    }
                }}>
                <div style={styles.container}>
                    <div
                        ref='dialog'
                        style={{
                            ...styles.dialog,
                            marginTop: this.props.isOpen ? this.props.top || styles.dialog.marginTop : '10rem',
                            borderWidth: this.props.isOpen ? styles.dialog.borderWidth : 0,
                            paddingTop: this.props.isOpen ? styles.dialog.paddingTop : 0,
                            paddingBottom: this.props.isOpen ? styles.dialog.paddingBottom : 0,
                            maxHeight: this.props.isOpen ? '90rem' : 0,
                        }}
                        onClick={event => event.stopPropagation()}>
                        <div style={styles.header}>
                            {this.props.children && this.props.children.length > 1
                                ? this.props.children[1]
                                : this.renderTitle
                                    ? this.renderTitle.bind(this)()
                                    : null
                            }
                        </div>
                        {this.props.isOpen || this.state.visible
                            ? this.props.children
                                ? this.props.children.length > 0 ? this.props.children[0] : this.props.children
                                : this.renderBody
                                    ? this.renderBody.bind(this)()
                                    : null
                            : null
                        }
                    </div>
                </div>
            </div>
        </span>;
    }
};
